import { baseUniDriverFactory as createBaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export const baseUniDriverFactory = (base) => {
  const baseUniDriver = createBaseUniDriver(base);
  return {
    /**
     * Checks whether the component found with the given data hook
     * @returns {Promise<boolean>}
     */
    exists: () => baseUniDriver.exists(),

    /**
     * Gets the component root element
     * @returns {Promise<any>}
     */
    element: () => baseUniDriver.element(),

    /**
     * Clicks on the component root element
     * @returns {Promise<void>}
     */
    click: () => baseUniDriver.click(),
  };
};
